import {ActionMenu, DeleteActionItem, NotificationActionItem} from '../notifications.styles';

interface BulkActionsMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  loading: boolean;
  canMarkAllAsRead: boolean;
  hasNotifications: boolean;
  onMarkAllAsRead: () => Promise<void>;
  onDeleteAll: () => Promise<void>;
  onClose: () => void;
}

export const BulkActionsMenu = ({
  anchorEl,
  open,
  loading,
  canMarkAllAsRead,
  hasNotifications,
  onMarkAllAsRead,
  onDeleteAll,
  onClose,
}: BulkActionsMenuProps) => {
  const handleMarkAllAsRead = () => {
    void onMarkAllAsRead();
  };

  const handleDeleteAll = () => {
    void onDeleteAll();
  };

  return (
    <ActionMenu anchorEl={anchorEl} open={open} onClose={onClose} PaperProps={{sx: {width: 273}}}>
      <NotificationActionItem onClick={handleMarkAllAsRead} disabled={!canMarkAllAsRead || loading}>
        Пометить все сообщения прочитанными
      </NotificationActionItem>
      <DeleteActionItem onClick={handleDeleteAll} disabled={!hasNotifications || loading}>
        Удалить все сообщения
      </DeleteActionItem>
    </ActionMenu>
  );
};
